import { create } from "zustand";
import { onAuthStateChanged, User as FirebaseUser } from "firebase/auth";
import { auth } from "../lib/firebase";

interface AuthState {
  user: FirebaseUser | null;
  loading: boolean;
}

export const useAuthStore = create<AuthState>(set => ({
  user: null,
  loading: true
}));

onAuthStateChanged(
  auth,
  user => {
    useAuthStore.setState({ user: user, loading: false });
  },
  error => {
    useAuthStore.setState({ loading: false });
  }
);
